export type RaffleJourneyTarget = 'register' | 'participants' | 'result';

export function raffleJourneyTargetForStatus(status: string | undefined): RaffleJourneyTarget {
  const normalized = String(status || 'registering').trim().toLowerCase();
  if (['settled', 'paid', 'voided', 'cancelled', 'canceled'].includes(normalized)) return 'result';
  if (['locked', 'full', 'settling', 'drawing'].includes(normalized)) return 'participants';
  return 'register';
}

export function raffleAdditionalEntryCapacity({
  activeTickets,
  existingEntries,
  totalEntries,
  maxTotalEntries,
  maxEntriesPerUser,
}: {
  activeTickets: number;
  existingEntries: number;
  totalEntries: number;
  maxTotalEntries: number;
  maxEntriesPerUser: number;
}) {
  const tickets = nonNegativeInteger(activeTickets);
  const eventLimit = nonNegativeInteger(maxTotalEntries);
  const userLimit = nonNegativeInteger(maxEntriesPerUser);
  const eventRemaining = eventLimit > 0
    ? Math.max(0, eventLimit - nonNegativeInteger(totalEntries))
    : tickets;
  const userRemaining = userLimit > 0
    ? Math.max(0, userLimit - nonNegativeInteger(existingEntries))
    : tickets;
  return Math.max(0, Math.min(tickets, eventRemaining, userRemaining));
}

function nonNegativeInteger(value: number) {
  return Math.max(0, Math.floor(Number.isFinite(value) ? value : 0));
}
